import { createSlice } from "@reduxjs/toolkit";

export const cameraReducer = createSlice({
     name: "camera",
     initialState: {
          cameraImage: null,
     },
     reducers: {
          setCameraImage: (state, action) => {
               state.cameraImage = action.payload;
          },
          resetCameraImage: (state) => {
               state.cameraImage = null;
          },
     },
});

export const { setCameraImage, resetCameraImage } = cameraReducer.actions;
export default cameraReducer.reducer;

// helps us pull information from store
export const selectCameraImage = (state) => state.camera.cameraImage;